
import React, {Component} from 'react';
import { getSkill,insertOrUpdateSkill} from '../../util/APIUtils';
import {SESSION_USER} from '../../constants';
import NotFound from '../../common/NotFound';
import ServerError from '../../common/ServerError';
import Loading from '../../common/Loading';

import {Field, reduxForm} from 'redux-form';
import {Provider} from "react-redux";
import Store from '../../helpers/Store';
import {inputField, textAreaField} from '../../helpers/Error';

const validate = (values, props) => {
    const errors = {};
    if (!values.name) {
        errors.name = 'Name field required'
    }
    return errors
};

class skiForm extends React.Component {

  /*  constructor(props) {
        super(props);
    }*/

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="form-body">
                    <div className="row p-t-20">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Skill Name  </label>
                                <Field type="text" className="form-control" name="name" fieldValue={this.props.states.name}
                                       component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Zoho Id</label>
                               <Field type="text" className="form-control" name="zohoId" fieldValue={this.props.states.zohoId}
                                       component={inputField}
                                       onChange={this.props.changeState}/></div>
                        </div>
                    </div>
                     <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Status</label>
                               <Field type="text" className="form-control" name="status" fieldValue={this.props.states.status}
                                       component={inputField}
                                       onChange={this.props.changeState}/></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Description</label>
                                <Field rows="3" cols="24" component={textAreaField} name="description" className='form-control' id="description" value={this.props.states.description} onChange={this.props.handleChange}/>
                            </div>
                        </div>
                    </div>
                </div>
                <Field type="hidden" name="id" id="id" fieldValue={this.props.states.id} component={inputField}/>
                <div className="form-actions">
                    <button type="submit" className="btn btn-primary btn-rounded"> <i className="fa fa-check"></i> Save</button>
                    &nbsp;&nbsp;&nbsp;
                    <a href="/skills" className="btn btn-inverse btn-rounded" >Cancel</a>
                </div>
            </form>
        );
    }
}

const SkiForm = reduxForm({
    form: 'skill_form',
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    updateUnregisteredFields: true,
    validate
})(skiForm);


export default class SkillForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
                name: '',
                description: '',
                zohoId:'',
                status:'1',
                id: '' ,
                loading: true
        }
        this.loadskill = this.loadskill.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);   
    }
   

    componentDidMount() {

        const skillId = this.props.match.params.skillId;
        if(skillId>0){
                this.loadskill(skillId);
        }else{
           this.setState({loading:false});
        }
    }

    componentDidUpdate(nextProps) {
       if(this.props.match.params.skillId !== nextProps.match.params.skillId) {
             this.loadskill(nextProps.match.params.skillId); 
        }   
    }

    loadskill(skillId) {
        
                getSkill(skillId)
                .then(response => {

                    this.setState({
                        name: response.name,
                        description: response.description,
                        status:response.status,
                        zohoId:response.zohoId,
                        id: response.id,
                        loading: false
                    });
                     
                   // console.log("response");
                   // console.log(this.state.skill.name);
                }).catch(error => {
                    if(error.status === 404) {
                        this.setState({
                            notFound: true,
                        });
                    } else {
                        this.setState({
                            serverError: true,
                        });        
                    }
                });
    }

    handleChange(event) {      

        const target = event.target;   
        const inputValue = target.value;
        this.setState({
            [target.name] : inputValue
        });
    }

    onSubmit = (values, dispatch) => {
        const fields = values;
           let user = JSON.parse(localStorage.getItem(SESSION_USER));
            //alert("in"); 
            //console.log(user);
           
            fields["userId"] = user.id;
            //console.log(fields);
           
            insertOrUpdateSkill(fields)
            .then(response => {   
                this.props.history.push("/skills");
            }).catch(error => {             
                       this.setState({
                            serverError: true,
                        });   
            })
    
    };  

	  render(){
      
       if(this.state.notFound) {
            return <NotFound />;
        }

        if(this.state.serverError) {
            return <ServerError />;
        }

        if(this.state.loading) {
          //return 'Loading...'
           return <Loading />;
        } 

     

    return (
         <div>
       <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor m-b-0 m-t-0">Skill Form</h3>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Home</li>
                            <li className="breadcrumb-item active">Skill</li>
                        </ol>
                    </div>
                    <div className="col-md-7 col-4 align-self-center">
                            
		                       
                    </div>


                    
            
       </div>
               <div className="row">
                    <div className="col-12">
                        <div className="card card-outline-info">
                            <div className="card-header">
                                <h4 className="m-b-0 text-white">Skill form</h4>
                            </div>
                              <div className="card-body">
                                  <Provider store={Store}>
                                      <SkiForm changeState={this.handleChange} states={this.state} initialValues={this.state} onSubmit={this.onSubmit}/>
                                  </Provider>
                              </div>

                        </div>
                     </div> 
                  </div>   
                  </div>   
          );
  }

 
}